import styled from 'styled-components'

import { Button } from '@reveni-io/reveni-ui'

export const ToggleButton = styled(Button)`
  margin-top: ${props => props.theme.whiteLabel.spacing.sp16};
`
